import React, { Suspense } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { Preloader } from "components";
import { SEEProgram } from "routes";

function App() {
  return (
    <Router>
      <Suspense fallback={<Preloader />}>
        <Route path="/" component={SEEProgram} />
      </Suspense>
    </Router>
  );
}

export default App;
